import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface RestoreVDRFileRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const RestoreVDRFile = createAsyncThunk(
    'dataRoom/restoreFile',
    async (
        { engagementId, fileId, fileSourceType }: RestoreVDRFileRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.put(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/restore?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not restore file at the moment.',
                    'error'
                );
                throw new Error('Failed to restore file');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while restoring file.',
                'error'
            );
            throw error;
        }
    }
);
